import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import UserDids from "../components/Messages/userDids/Container.did";
import ConversationContainer from "../components/Messages/conversations/Conversations.container";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import ChatContainer from "../components/Messages/chat/chat.container";
import { useMessageSocket } from "../hooks/socket/message";
import { useFfmpegLoader } from "../hooks/ffmpeg/useLoadffmpeg";
import { clearPast24HoursOfflineMessages } from "../store/slices/offline_messages.slice";
import { useGetSmsDids } from "../hooks/apis/SmsDids.api";
import useCallbackState from "../hooks/useCallBackState";
import { setDraftParticipants } from "../store/slices/conversation.slice";

const MessagesPage = React.memo(() => {
    const dispatch: AppDispatch = useDispatch();

    const { draftParticipants, selectedConversation } = useSelector((state: RootState) => state.conversation);
    const { messages: offlineMessages } = useSelector((state: RootState) => state.offlineMessages);

    const [open, setOpen] = useState(true);
    const [isNewConversation, setIsNewConversation] = useState<boolean>(false);
    const [participants, setParticipants] = useCallbackState<string[]>([]);

    const { sendOutgoingMessage, deleteMessage } = useMessageSocket();
    const { load: loadffmpeg, ffmpegRef } = useFfmpegLoader();

    const { isFetching: isLoading } = useGetSmsDids();

    useEffect(() => {
        dispatch(clearPast24HoursOfflineMessages());
    }, []);


    useEffect(() => {
        loadffmpeg();
    }, []);

    useEffect(() => {
        if (!draftParticipants.length) return;
        setParticipants(draftParticipants);
        setIsNewConversation(true);
        dispatch(setDraftParticipants([]));
    }, [draftParticipants]);

    useEffect(() => {
        if (selectedConversation || isNewConversation) return;
        const pendingConversation = offlineMessages.find(
            (message) => !message.conversation_id
        );
        if (!pendingConversation) return;

        setParticipants(
            pendingConversation.conversation_participants?.length
                ? pendingConversation.conversation_participants
                : [pendingConversation.participant]
        );
        setIsNewConversation(true);
    }, [offlineMessages, selectedConversation, isNewConversation]);

    useEffect(() => {
        if (!selectedConversation) return;
        setIsNewConversation(false);
        setParticipants([]);
    }, [selectedConversation?.conversation_id]);

    const rowStyle: React.CSSProperties = {
        height: "100%",
        width: "100%"

    };

    const ConversationContainerStyle: React.CSSProperties = {
        height: "100%",
        background: "white",
        width: "100%"
    };

    const ChatContainerStyle: React.CSSProperties = {
        height: "100%",
        maxWidth: "100%"
    };

    return (
        <Row style={rowStyle}>
            <Col span={open ? 5 : 2} style={{ flex: "1 1 auto", width: "100%", height: "100%", transition: "all 0.3s ease-in-out 0.1s" }}>
                <UserDids
                    isLoading={isLoading}
                    showCounter={true}
                    setSidebarOpen={setOpen}
                    sidebarOpen={open}
                    setIsNewConversation={setIsNewConversation}
                />
            </Col>
            <Col span={7} style={ConversationContainerStyle}>
                <ConversationContainer setParticipants={setParticipants} setIsNewConversation={setIsNewConversation} />
            </Col>
            <Col flex={"auto"} style={ChatContainerStyle}>
                <ChatContainer
                    deleteMessage={deleteMessage}
                    ffmpegRef={ffmpegRef}
                    sendMessage={sendOutgoingMessage}
                    isNewConversation={isNewConversation}
                    setIsNewConversation={setIsNewConversation}
                    participants={participants}
                    setParticipants={setParticipants}
                />
            </Col>
        </Row>
    );
});

export default MessagesPage;
